<script lang="ts">
export default {
    name: 'BaseLoading',
};
</script>

<script lang="ts" setup>
import CircleLoading from './CircleLoading.vue';
import InfinityLoading from './InfinityLoading.vue';
import type { LoadingType } from './types';

interface Props {
    /**
     * Loading类型
     */
    type?: LoadingType;
    /**
     * colorful为false的时候loading是白色
     */
    colorful?: boolean;
    /**
     * 设置loading颜色
     */
    customColor?: string;
    /**
     * 是不是占整屏
     */
    fullscreen?: boolean;
    /**
     * loading是不是居中
     */
    stayCenter?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    type: 'infinity',
    colorful: true,
});
</script>

<template>
    <CircleLoading v-if="type === 'circle'" :colorful="colorful" />
    <InfinityLoading
        v-else
        :colorful="colorful"
        :custom-color="customColor"
        :fullscreen="fullscreen"
        :stay-center="stayCenter"
    />
</template>
